import clsx from 'clsx';

/**
 * Tail‑wind powered button
 * ────────────────────────
 * Props
 * • variant  : 'primary' | 'secondary' | 'danger'
 * • size     : 'sm' | 'md' | 'lg'
 * • loading  : boolean  – shows a spinner & disables click
 * • …rest    : native <button> props
 */
const variants = {
  primary:   'bg-dominant-purple text-white hover:bg-rich-gold',
  secondary: 'bg-soft-yellow  text-charcoal hover:bg-dominant-purple',
  danger:    'bg-red-500      text-white hover:bg-red-600',
};

const sizes = {
  sm: 'px-3 py-1 text-sm',
  md: 'px-4 py-2',
  lg: 'px-5 py-3 text-lg',
};

export default function Button({
  children,
  variant = 'primary',
  size = 'md',
  loading = false,
  className = '',
  disabled,
  ...rest
}) {
  return (
    <button
      className={clsx(
        'inline-flex items-center justify-center rounded font-medium transition-colors duration-200',
        'disabled:opacity-50 disabled:cursor-not-allowed',
        variants[variant],
        sizes[size],
        className,
      )}
      disabled={disabled || loading}
      {...rest}
    >
      {loading && (
        <svg
          className="mr-2 h-4 w-4 animate-spin"
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
            fill="none"
          />
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
          />
        </svg>
      )}
      {children}
    </button>
  );
}
